module.exports = __webpack_public_path__ + "img/totop_nor.669c0301.svg";